import React, { useEffect, useRef, useState } from 'react';
import './CopyTextButton.css';

export default function CopyTextButton({ value, label = 'value', className = '', children = null }) {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef(null);
  const text = value == null ? '' : String(value).trim();

  useEffect(() => () => window.clearTimeout(timerRef.current), []);

  const handleCopy = async () => {
    if (!text) return;

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        const scratch = document.createElement('textarea');
        scratch.value = text;
        scratch.setAttribute('readonly', '');
        scratch.style.position = 'fixed';
        scratch.style.opacity = '0';
        document.body.appendChild(scratch);
        scratch.select();
        document.execCommand('copy');
        document.body.removeChild(scratch);
      }

      setCopied(true);
      window.clearTimeout(timerRef.current);
      timerRef.current = window.setTimeout(() => setCopied(false), 1200);
    } catch {
      // The value remains visible to select manually if the browser blocks copy.
    }
  };

  if (!text) return null;

  return (
    <button
      type="button"
      className={['copy-text-button', copied ? 'copy-text-button--copied' : '', className].filter(Boolean).join(' ')}
      onClick={handleCopy}
      title={copied ? 'Copied' : `Copy ${label}`}
      aria-label={`Copy ${label}`}
    >
      {children}
      <i className={`bi ${copied ? 'bi-check-lg' : 'bi-clipboard'}`} aria-hidden="true" />
    </button>
  );
}